import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { combineLatest } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'children-form',
    templateUrl: './children-form.component.html',
    styleUrls: ['./children-form.component.scss'],
    standalone: false
})
export class ChildrenFormComponent
  extends EaSubscriptionBuilder
  implements OnInit, AfterViewInit
{
  @Input() col: number = 6;
  countries: any[];
  departments: any[];
  legalCapacities: any[];
  sessionConsultant: boolean;

  options: FormControlOption[] = [
    { value: 'M', label: 'Garçon', suffix: { title: 'A' } },
    { value: 'F', label: 'Fille', suffix: { title: 'B' } },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private cd: ChangeDetectorRef,
    private referenceDao: ReferenceDao,
  ) {
    super(formConstructor);
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    this.sessionConsultant =
      !!this.subscriptionFacade?.getPledge() &&
      !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    combineLatest([
      this.referenceDao.getLegalCapacity(),
      this.referenceDao.getCountries(),
      this.referenceDao.getDepartment(),
    ]).subscribe(([legalCapacities, countries, departments]) => {
      this.departments = departments;
      this.countries = countries;
      this.legalCapacities = legalCapacities;
    });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
